import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, BadgeCheck } from 'lucide-react';
import { Button } from './ui/button';

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-fx-navy text-white">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?w=1920&q=80"
          alt="Heavy construction equipment"
          className="w-full h-full object-cover fx-ken opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-fx-navy via-fx-navy/85 to-fx-navy/60" />
        <div className="fx-grain" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-28 lg:py-40">
        <div className="max-w-3xl fx-fade-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/15 backdrop-blur-sm text-xs uppercase tracking-widest text-fx-gold">
            <span className="w-1.5 h-1.5 rounded-full bg-fx-gold animate-pulse" />
            Canadian Equipment Finance Company
          </div>
          <h1 className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05]">
            Enabling Scale Through<br />
            <span className="text-fx-gold">Equipment Financing</span>
          </h1>
          <p className="mt-6 text-lg text-white/80 max-w-2xl leading-relaxed">
            From a single excavator to a full fleet refresh, Foxstone Funding delivers flexible leasing, working capital and refinancing solutions tailored to your cashflow — with approvals in hours, not days.
          </p>
          <div className="mt-9 flex flex-wrap gap-4">
            <Button asChild size="lg" className="bg-fx-gold hover:bg-[#b88e36] text-fx-navy font-semibold rounded-sm h-12 px-7">
              <Link to="/contact">Contact Us <ArrowRight className="w-4 h-4 ml-2" /></Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-white/30 bg-transparent text-white hover:bg-white hover:text-fx-navy rounded-sm h-12 px-7">
              <Link to="/equipment-leasing">Explore Leasing</Link>
            </Button>
          </div>

          <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 text-sm">
            {[
              { icon: BadgeCheck, label: '93% approval rate' },
              { icon: ShieldCheck, label: 'Independent & Canadian-owned' },
            ].map((it, i) => (
              <div key={i} className="flex items-center gap-2.5 text-white/80">
                <it.icon className="w-4 h-4 text-fx-gold" />
                <span>{it.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
